"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_dom_1 = __importDefault(require("react-dom"));
var utils_1 = require("../../utils");
function Portal(_a) {
    var children = _a.children;
    var defaultNode = react_1.useState(document.createElement('div'))[0];
    react_1.useEffect(function () {
        var createPortal = function () {
            document.body.appendChild(defaultNode);
        };
        createPortal();
        return function cleanup() {
            document.body.removeChild(defaultNode);
        };
    }, [defaultNode]);
    return utils_1.canUseDOM ? react_dom_1.default.createPortal(children, defaultNode) : null;
}
exports.default = Portal;
//# sourceMappingURL=Portal.js.map